import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import HomePage from './pages/HomePage';
import NieuwsPage from './pages/NieuwsPage';
import PartijenPage from './pages/PartijenPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminDashboard from './pages/admin/Dashboard';
import AdminNews from './pages/admin/News';
import AdminUsers from './pages/admin/Users';
import UserDashboard from './pages/user/Dashboard';
import ArticlePage from './pages/ArticlePage';

function Navigation() {
  const { user, isAuthenticated, logout } = useAuth();
  const location = useLocation();

  return (
    <nav className="bg-gradient-to-r from-red-700 via-white to-blue-700 shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold text-gray-800">
            <span className="text-red-600">Politiek</span>Direct
          </Link>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className={`hover:text-red-600 ${location.pathname === '/' ? 'text-red-600 font-semibold' : 'text-gray-700'}`}>Home</Link>
            <Link to="/nieuws" className={`hover:text-red-600 ${location.pathname === '/nieuws' ? 'text-red-600 font-semibold' : 'text-gray-700'}`}>Nieuws</Link>
            <Link to="/partijen" className={`hover:text-red-600 ${location.pathname === '/partijen' ? 'text-red-600 font-semibold' : 'text-gray-700'}`}>Partijen</Link>
            {isAuthenticated ? (
              <>
                {user.role === 'admin' ? (
                  <Link to="/admin" className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">Admin</Link>
                ) : (
                  <Link to="/dashboard" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">Dashboard</Link>
                )}
                <button onClick={logout} className="text-gray-700 hover:text-red-600">Uitloggen</button>
              </>
            ) : (
              <Link to="/login" className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">Inloggen</Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 mt-20">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">PolitiekDirect</h3>
            <p className="text-gray-400">Onafhankelijk politiek nieuws en analyse. Altijd actueel, altijd kritisch.</p>
          </div>
          <div>
            <h4 className="font-bold mb-4">Snelle Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/nieuws" className="hover:text-white">Nieuws</Link></li>
              <li><Link to="/partijen" className="hover:text-white">Partijen</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <p className="text-gray-400">redactie@politiekdirect.nl</p>
            <p className="text-gray-400">KvK: 99442760</p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-500">
          <p>&copy; 2026 PolitiekDirect. Alle rechten voorbehouden.</p>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/nieuws" element={<NieuwsPage />} />
        <Route path="/nieuws/:id" element={<ArticlePage />} />
        <Route path="/partijen" element={<PartijenPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/nieuws" element={<AdminNews />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
